import { log } from '@execonline-inc/logging';
import { AlreadyTranslatedText } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Task } from 'taskarian';
import { AppyError } from '../../../../../../Appy';
import { MissingLinkError, findLinkT } from '../../../../../../LinkyLinky';
import { Link } from '../../../../../../Resource/Types';
import LearningCollectionEditStore from '../../../Edit/Store';
import { SectionContext } from '../../../Types';
import ExperienceCatalogModal from './ExperienceCatalogModal';
import ModalTrigger from './ModalTrigger';
import Reactions from './Reactions';
import Store from './Store';
import { LearningCollectionEditFormResource } from '../../../Edit/Store/Types';

interface Props {
  learningDesignName: AlreadyTranslatedText;
  learningCollectionStore: LearningCollectionEditStore;
  context: SectionContext;
  learningCollectionEditFormResource: LearningCollectionEditFormResource;
}

function ExperienceCatalog({
  learningCollectionStore,
  learningDesignName,
  context,
  learningCollectionEditFormResource,
}: Props) {
  const store = React.useRef(new Store(learningCollectionStore.selectedProductLicense)).current;

  React.useEffect(() => {
    Task.succeed<MissingLinkError | AppyError, ReadonlyArray<Link>>(learningCollectionStore.links)
      .andThen(findLinkT('experiences'))
      .fork(
        (err) => log('Load experiences failed:', err),
        (link) => store.waitingWithLink(link),
      );
  }, [learningCollectionStore.links, store]);

  return (
    <>
      <ModalTrigger store={store} />
      <Reactions store={store} />
      <ExperienceCatalogModal
        store={store}
        learningDesignName={learningDesignName}
        learningCollectionStore={learningCollectionStore}
        context={context}
        learningCollectionEditFormResource={learningCollectionEditFormResource}
      />
    </>
  );
}

export default observer(ExperienceCatalog);
